import { Context } from '@absmartly/javascript-sdk';
import { AbSmartlyProviderContext } from 'src/components/absmartly';
import { Variant } from '../types';

type SetupForcedVariantsProps = {
  context: Context;
  experimentMap: AbSmartlyProviderContext['experimentMap'];
  experimentPrefix?: string;
};
export const setupForcedVariants = ({
  context,
  experimentMap,
  experimentPrefix = 'test_',
}: SetupForcedVariantsProps) => {
  const experimentsFromUrlParams = window?.location?.search
    ?.split('?')[1]
    ?.split('&')
    ?.filter((x) => x.startsWith(experimentPrefix))
    ?.map((x) => x.slice(experimentPrefix.length));

  experimentsFromUrlParams?.forEach((x: string) => {
    const [key, variant] = x.split('=');
    const experiment = experimentMap.get(key);
    if (!experiment) {
      console.error(`${key} is not a valid experiment name`);
      return;
    }
    const variants = experiment.variants as Variant[];
    const targetIndex = variants.findIndex(({ name }) => name === variant);
    if (targetIndex !== -1) {
      context.override(key, targetIndex);
    }
  });
};
